import { render, staticRenderFns } from "./genomicsIndex.vue?vue&type=template&id=38c65c82&scoped=true"
import script from "./genomicsIndex.vue?vue&type=script&lang=js"
export * from "./genomicsIndex.vue?vue&type=script&lang=js"
import style0 from "./genomicsIndex.vue?vue&type=style&index=0&id=38c65c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c65c82",
  null
  
)

export default component.exports